export function staffAttendance(state = [], action) {
  switch (action.type) {
    case "STAFF_ATTENDANCE_FETCHED":
      return action.data;
    default:
      return state;
  }
}
